import * as React from 'react';
import { Config } from '../../helper';
import { OpenSearchDropdown } from '../components';

export default function CompactLayoutFilters(props) {
  const {
    label = '',
    facets = [],
  } = props;

  return (
    <div className='filters'>
      {label && (
        <div className='filters__header'>
          <p className='p--medium fw-bold mb-0'>{label}</p>
        </div>
      )}

      {facets.length > 0 && facets.map(facetConfig => {
        const {field, label: facetLabel, hidden = false, order} = facetConfig;

        return (
          <OpenSearchDropdown key={field} field={field} label={facetLabel} hidden={hidden} order={order} show={Config.DisplayOptions.FacetSize}/>
        );
      })}
    </div>
  );
}
